import React from "react";
import { Box, Typography, IconButton, FormControlLabel, Checkbox } from "@mui/material";
import { ChevronLeft, ChevronRight, Visibility, VisibilityOff, PersonAdd } from "@mui/icons-material";
import MicIcon from "@mui/icons-material/Mic";
import MusicNoteIcon from "@mui/icons-material/MusicNote";

const CalendarToolbar = ({ goToPrevQuarter, goToNextQuarter, getQuarterLabel, showChallenges, setShowChallenges, showContests, setShowContests, showKaraoke, setShowKaraoke, showDance, setShowDance, showRegistrations, setShowRegistrations, goToToday }) => (
<>
          {/* Navigation */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 2,
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={goToPrevQuarter} size="small">
                <ChevronLeft />
              </IconButton>
              <Typography
                variant="h6"
                sx={{ minWidth: 220, textAlign: "center", fontWeight: 600 }}
              >
                {getQuarterLabel()}
              </Typography>
              <IconButton onClick={goToNextQuarter} size="small">
                <ChevronRight />
              </IconButton>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
              {/* Filters */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showChallenges}
                    onChange={(e) => setShowChallenges(e.target.checked)}
                    size="small"
                    sx={{ color: "#3b82f6", "&.Mui-checked": { color: "#3b82f6" } }}
                  />
                }
                label={<Typography variant="body2">Challenges</Typography>}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showContests}
                    onChange={(e) => setShowContests(e.target.checked)}
                    size="small"
                    sx={{ color: "#8b5cf6", "&.Mui-checked": { color: "#8b5cf6" } }}
                  />
                }
                label={<Typography variant="body2">Contest Voting</Typography>}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showKaraoke}
                    onChange={(e) => setShowKaraoke(e.target.checked)}
                    size="small"
                    sx={{ color: "#7c3aed", "&.Mui-checked": { color: "#7c3aed" } }}
                  />
                }
                label={<Typography variant="body2">Karaoke</Typography>}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showDance}
                    onChange={(e) => setShowDance(e.target.checked)}
                    size="small"
                    sx={{ color: "#14b8a6", "&.Mui-checked": { color: "#14b8a6" } }}
                  />
                }
                label={<Typography variant="body2">Dance</Typography>}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showRegistrations}
                    onChange={(e) => setShowRegistrations(e.target.checked)}
                    size="small"
                    sx={{ color: "#10b981", "&.Mui-checked": { color: "#10b981" } }}
                  />
                }
                label={<Typography variant="body2">Registrations</Typography>}
              />

              <Box
                onClick={goToToday}
                sx={{
                  padding: "4px 12px",
                  borderRadius: "4px",
                  border: "1px solid #142C5C",
                  color: "#142C5C",
                  cursor: "pointer",
                  fontSize: "14px",
                  "&:hover": { backgroundColor: "rgba(20,44,92,0.05)" },
                }}
              >
                Today
              </Box>
            </Box>
          </Box>

          {/* Legend */}
          <Box sx={{ display: "flex", gap: 3, marginBottom: 2, flexWrap: "wrap" }}>
            <Typography variant="caption" sx={{ fontWeight: 600, color: "#666" }}>
              Challenges:
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 12, height: 12, backgroundColor: "#fff3cd", border: "2px solid #f59e0b", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Scheduled</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 12, height: 12, backgroundColor: "#dbeafe", border: "2px solid #3b82f6", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Active</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 12, height: 12, backgroundColor: "#fee2e2", border: "2px solid #ef4444", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Ended</Typography>
            </Box>
            <Box sx={{ width: "1px", backgroundColor: "#ddd", mx: 1 }} />
            <Typography variant="caption" sx={{ fontWeight: 600, color: "#666" }}>
              Contests:
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Visibility sx={{ fontSize: 14, color: "#22c55e" }} />
              <Box sx={{ width: 12, height: 12, backgroundColor: "#dcfce7", border: "2px solid #22c55e", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Visible</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <VisibilityOff sx={{ fontSize: 14, color: "#9ca3af" }} />
              <Box sx={{ width: 12, height: 12, backgroundColor: "#f3f4f6", border: "2px solid #9ca3af", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Hidden</Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box sx={{ width: 12, height: 12, backgroundColor: "#fce7f3", border: "2px solid #ec4899", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Ended</Typography>
            </Box>
            <Box sx={{ width: "1px", backgroundColor: "#ddd", mx: 1 }} />
            <Typography variant="caption" sx={{ fontWeight: 600, color: "#666" }}>
              Karaoke:
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MicIcon sx={{ fontSize: 14, color: "#7c3aed" }} />
              <Box sx={{ width: 12, height: 12, backgroundColor: "#ddd6fe", border: "2px solid #7c3aed", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Available</Typography>
            </Box>
            <Box sx={{ width: "1px", backgroundColor: "#ddd", mx: 1 }} />
            <Typography variant="caption" sx={{ fontWeight: 600, color: "#666" }}>
              Dance:
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <MusicNoteIcon sx={{ fontSize: 14, color: "#14b8a6" }} />
              <Box sx={{ width: 12, height: 12, backgroundColor: "#99f6e4", border: "2px solid #0f766e", borderRadius: "2px" }} />
              <Typography variant="caption" color="#666">Available</Typography>
            </Box>
            <Box sx={{ width: "1px", backgroundColor: "#ddd", mx: 1 }} />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PersonAdd sx={{ fontSize: 14, color: "#10b981" }} />
              <Typography variant="caption" color="#666">Registrations</Typography>
            </Box>
          </Box>
</>
);

export default CalendarToolbar;
